import { Component, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';
import { ContractTypeModel } from 'src/models/ContractTypeModel';
import { ProviderModel } from 'src/models/ProviderModel';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {NumAnnoMeseFilterComponent} from '../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';

@Component({
  selector: 'app-consuntivo-forecast-upload',
  templateUrl: './consuntivo-forecast-upload.component.html',
  styleUrls: ['./consuntivo-forecast-upload.component.scss']
})
export class ConsuntivoForecastUploadComponent extends BaseGeneralComponent implements OnInit, OnDestroy, OnChanges {

  uploadType: string;
  numAnnoMeseFormControl = new FormControl();
  numAnnoMese: number;
  registerForm: FormGroup;
  allMonth: any;
  enableUpload: boolean;
  showProvider: boolean;
  providerSelect: ProviderModel;
  statusSelected: any;

  getAllNumAnnoMeseSubscribe: Subscription;
  getPageSubscribe: Subscription;

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  
  constructor(private annoMeseService: NumAnnoMeseService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService) {
    super();

    this.providerSelect = new ProviderModel();
    this.enableUpload = true;
    this.registerForm = this.formBuilder.group({
      numAnnoMese: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      status: 'final'
    });
  }

  ngOnInit(): void {
    this.loaderService.display(true);
    this.uploadType = 'forecast';
    this.getAll();
  }

  ngOnChanges (changes: any) {
    this.numAnnoMese = changes;
    this.registerForm.patchValue({
      numAnnoMese: this.numAnnoMese
    });
  }

  getAll() {
    //TODO poco elegante questo modo di reperire il provider
    const providerDefault = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.getAllNumAnnoMeseSubscribe = this.annoMeseService.getAllMonth(providerDefault, new ContractTypeModel())
      .subscribe(
        (result: any) => {
          this.allMonth = this.filterFromDxc(providerDefault, result);
          this.numAnnoMese = this.allMonth[0];

          this.providerSelect = providerDefault;
          this.registerForm.patchValue({
            provider: this.providerSelect.cod
          });
          this.registerForm.patchValue({
            numAnnoMese: this.numAnnoMese
          });

          this.loaderService.display(false);
        });
  }

  getFirstYearMonth() {
    this.getPageSubscribe = this.annoMeseService.getFirtsAnnoMese()
      .subscribe(
        (numAnnoMeseResult: any) => {
          this.numAnnoMese = numAnnoMeseResult;
          this.registerForm.patchValue({
            numAnnoMese: this.numAnnoMese
          });
        });
  }

  ngOnDestroy(): void {
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  resetProvider() {
    this.showProvider = false;
    this.enableUpload = false;
    this.registerForm.patchValue({
      provider: null
    });
    this.providerSelect = new ProviderModel();
  }

  getElementSelectedProvider($event) {
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
    if (this.statusSelected) {
      this.enableUpload = true;
    }
  }

  getElementSelectedStatus($event) {
    this.statusSelected = $event;
    this.enableUpload = true;

    this.registerForm.patchValue({
      status: this.statusSelected
    });
  }

  onFileUploading() {
    this.loaderService.display(true);
  }

  onFileComplete() {
    this.loaderService.display(false);
  }
  
  get f() { return this.registerForm.controls; }
}
